import angular from 'angular'
import DOMPurify from 'dompurify'

/**
 * Provides our own $sanitize service in place of angular-sanitize,
 * so we can rely on dompurify everywhere.
 */
angular
  .module('webregister.factories')
  .factory('$sanitize', () => (html: string) => DOMPurify.sanitize(html))
